export const LOADER_FORMAL_EDUCATION_METRICS          = 'LOADER_FORMAL_EDUCATION_METRICS';
export const GET_FORMAL_EDUCATION_METRICS             = 'GET_FORMAL_EDUCATION_METRICS';
export const FORMAL_EDUCATION_METRICS_FAIL            = 'FORMAL_EDUCATION_METRICS_FAIL';
export const SAVE_LOADER_FORMAL_EDUCATION_METRICS     = 'SAVE_LOADER_FORMAL_EDUCATION_METRICS';
export const FORM_FORMAL_EDUCATION_METRICS_FAIL       = 'FORM_FORMAL_EDUCATION_METRICS_FAIL';

